import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";

import "./App.css";
/* Public Pages */
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import Forget from "./components/Forget";

import { ROUTES } from "./Routes/routes";

import AppLayout from "./AppLayout";
/* Route Modules */
import { dentistRoutes } from "./Routes/dentistRoutes";
import { centralHubRoutes } from "./Routes/centralHubRoutes";
import { managerRoutes } from "./Routes/managerRoutes";
import { designerRoutes } from "./Routes/designerRoutes";
import { millingRoutes } from "./Routes/millingRoutes";
import { deliveryRoutes } from "./Routes/deliveryRoutes";
import AboutUs from "./components/aboutus";
import Contact from "./components/Contact";
import Fordentist from "./components/Fordentist";
import Forlabs from "./components/Forlabs";
import Bookdemo from "./components/Bookdemo";
import Findadendtist from "./components/Findadenstist";
import Faq from "./components/Faq";
import Blogcomingsoon from "./components/Blogcomingsoon";
import RefundPolicy from "./components/RefundPolicy";
import Termsandconditions from "./components/Termsandconditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RazorpayTest from "./components/RazorpayTest";

/* ================= MAIN APP ================= */
const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!sessionStorage.getItem("token")
  );

  // useEffect(() => {
  //   const checkAuth = () => {
  //     setIsAuthenticated(!!sessionStorage.getItem("token"));
  //   };

  //   window.addEventListener("storage", checkAuth);

  //   return () => {
  //     window.removeEventListener("storage", checkAuth);
  //   };
  // }, []);

  useEffect(() => {
  const checkAuth = () => {
    setIsAuthenticated(!!sessionStorage.getItem("token"));
  };

  // Ask notification permission once
  if ("Notification" in window && Notification.permission === "default") {
    Notification.requestPermission();
  }

  const handleVisibilityChange = () => {
    if (document.hidden) {
       console.warn("Browser Minimized / Tab Hidden");
     
    } else {
      console.warn("Browser Active");
    }
  };

  window.addEventListener("storage", checkAuth);
  document.addEventListener(
    "visibilitychange",
    handleVisibilityChange
  );

  return () => {
    window.removeEventListener("storage", checkAuth);
    document.removeEventListener(
      "visibilitychange",
      handleVisibilityChange
    );
  };
}, []);

  /* ================= ROUTER ================= */
  const router = createBrowserRouter([
    {
      path: "/",
      element: <AppLayout isAuthenticated={isAuthenticated} />,
      children: [
        /* 🌐 PUBLIC ROUTES */
        { path: ROUTES.HOME, element: <Home /> },
        { path: ROUTES.LOGIN, element: <Login /> },
        { path: ROUTES.REGISTER, element: <Register /> },
        { path: ROUTES.FORGOT_PASSWORD, element: <Forget /> },
        { path: ROUTES.AboutUs, element: <AboutUs /> },
        { path: ROUTES.Contact, element: <Contact/> },
        { path: ROUTES.Fordentist, element: <Fordentist/> },
        { path: ROUTES.Forlabs, element: <Forlabs/> },
        { path: ROUTES.Bookdemo, element: <Bookdemo/> },
        { path: ROUTES.Findadendtist, element: <Findadendtist/> },
        { path: ROUTES.Faq, element: <Faq/> },
        { path: ROUTES.Blogcomingsoon, element: <Blogcomingsoon/> },
        { path: ROUTES.Termsandconditions, element: <Termsandconditions/> },
        { path: ROUTES.RefundPolicy, element: <RefundPolicy/> },
        { path: ROUTES.PrivacyPolicy, element: <PrivacyPolicy/> },
      
        { path: ROUTES.RazorpayTest, element: <RazorpayTest /> },
        
        
         

        /* 🔐 ROLE ROUTES */
        ...dentistRoutes,
        ...centralHubRoutes,
        ...managerRoutes,
        ...designerRoutes,
        ...millingRoutes,
        ...deliveryRoutes,
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;